import { injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { FetchError } from "src/shared/errors/fetch-error";
import { MobileDocumentDownloadRequest } from "src/containers/documents-download/types";

@injectable()
class StaticDocumentDownloadService {
    @autoBind
    download(url: string): Promise<Blob> {
        return fetch(url).then((res) => {
            if (res.ok) {
                return res.blob() as unknown as Blob;
            }
            throw new FetchError(res);
        });
    }

    @autoBind
    downloadMobile(url: string): void {
        const payload: MobileDocumentDownloadRequest = {
            method: "GET",
            endpoint: url,
            headers: {},
        };

        window.MobileDocumentDownload?.postMessage(JSON.stringify(payload));
    }
}

export { StaticDocumentDownloadService };
